process.env.FIRESTORE_EMULATOR_HOST = 'localhost:8888'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/database'
import env from './env'
export interface FirestoreConnections {
  firebase: any,    // I though it was firebase.app.App, but looks like does not compile yet
  db: firebase.firestore.Firestore,
  firestorage: firebase.storage.Storage,
  functions: firebase.functions.Functions,
  projectId: string,
  cleanupConnection: () => Promise<void>,
  clearDB: () => Promise<void>,
  serverTimestamp: any
}

const app = firebase.initializeApp(env.firebase)

const storage = firebase.storage()
let projectId = env.firebase.projectId
// console.log(process.env.NODE_ENV)
let db = firebase.firestore(app)
let cleanupConnection = async () => {
  console.warn('Cleanup Connections should not be ran on the real db, this is for testing purposes only')
}
let clearDB = async () => {
  console.warn('Clear DB should not be run on the real db, this is for testing purposes only')
}
if (process.env.NODE_ENV === 'test') {
  // console.warn('Running using the firestore emulator')
  const firebase = require('@firebase/testing')
  projectId = 'cloudcast-test-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
  db = firebase.initializeAdminApp({ projectId }).firestore()
  cleanupConnection = async () => {
    await Promise.all(firebase.apps().map(app => app.delete()))
  }
  clearDB = async () => {
    await firebase.clearFirestoreData({ projectId })
  }
}
// db.settings({ timestampsInSnapshots: true })

// get a server timestamp reference (= NOT a regular DATE object!)
const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp

const fb: FirestoreConnections = {
  firebase,
  db,
  firestorage: storage,
  functions: firebase.functions(),
  projectId,
  cleanupConnection,
  clearDB,
  serverTimestamp
}

export default fb
